<template>
  <div  class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 926px;">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">{{edit?'編輯排訪':'新增排訪'}}</h3>
        </div>
        <div class="modal-body" :class="{'section-loading': Loading}">
          <div class="row">
            <div class="col-5 scheduled_access-data">
              <div class="row mb-3">
                <div class="col-3 font-weight-bold d-flex justify-content-end mt-2">
                  客戶姓名
                </div>
                <div class="col-9">
                  <input type="text" v-model="nameBir" class="form-control" style="width: 180px" disabled alt="ch">
                </div>
              </div>
              <!-- <div class="row mb-3">
                <div class="col-3 font-weight-bold d-flex justify-content-end mt-1 f-size-15 pd-0">
                  此為全天事件
                </div>
                <div class="col-9">
                  <div class="switch-wrapper">
                    <label class="switch">
                      <input type="checkbox" v-model="allDayEvent" @change="handleToggle">
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
              </div> -->
              <div class="row mb-3" v-show="!allDayEvent">
                <div class="col-3 font-weight-bold d-flex justify-content-end mt-2">
                  開始時間
                </div>
                <div class="col-9">
                  <div class="d-flex justify-content-between" style="width: 220px;">
                    <date-picker
                        v-model="recordData.str_date"
                        :format="dateFormatter"
                        :language="dateLang"
                        :first-day-of-week="1" />
                    <select 
                        class="form-control non-select-arrow select-time"
                        v-model="recordData.str_hour">
                      <option value="00">00</option>
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                      <option value="16">16</option>
                      <option value="17">17</option>
                      <option value="18">18</option>
                      <option value="19">19</option>
                      <option value="20">20</option>
                      <option value="21">21</option>
                      <option value="22">22</option>
                      <option value="23">23</option>
                    </select>
                    <div class="d-flex font-weight-bold d-flex align-items-center justify-content-center">:</div>
                    <select 
                    class="form-control non-select-arrow select-time" 
                    v-model="recordData.str_minute">
                      <option value="00">00</option>
                      <option value="05">05</option>
                      <option value="10">10</option>
                      <option value="15">15</option>
                      <option value="20">20</option>
                      <option value="25">25</option>
                      <option value="30">30</option>
                      <option value="35">35</option>
                      <option value="40">40</option>
                      <option value="45">45</option>
                      <option value="50">50</option>
                      <option value="55">55</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row mb-3" v-show="!allDayEvent">
                <div class="col-3 font-weight-bold d-flex justify-content-end mt-2">
                  結束時間
                </div>
                <div class="col-9">
                  <div class="d-flex justify-content-between" style="width: 220px;">
                    <date-picker
                        v-model="recordData.end_date"
                        width="90px;"
                        :format="dateFormatter"
                        :language="dateLang"
                        :first-day-of-week="1" />
                    <select 
                    class="form-control non-select-arrow select-time" 
                    v-model="recordData.end_hour">
                      <option value="00">00</option>
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                      <option value="16">16</option>
                      <option value="17">17</option>
                      <option value="18">18</option>
                      <option value="19">19</option>
                      <option value="20">20</option>
                      <option value="21">21</option>
                      <option value="22">22</option>
                      <option value="23">23</option>
                    </select>
                    <div class="d-flex font-weight-bold d-flex align-items-center justify-content-center">:</div>
                    <select 
                    class="form-control non-select-arrow select-time" 
                    v-model="recordData.end_minute">
                      <option value="00">00</option>
                      <option value="05">05</option>
                      <option value="10">10</option>
                      <option value="15">15</option>
                      <option value="20">20</option>
                      <option value="25">25</option>
                      <option value="30">30</option>
                      <option value="35">35</option>
                      <option value="40">40</option>
                      <option value="45">45</option>
                      <option value="50">50</option>
                      <option value="55">55</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-3 font-weight-bold d-flex justify-content-end mt-2">
                  提醒
                </div>
                <div class="col-9">
                  <select class="form-control select-100" v-model="recordData.remind_type">
                    <option value="0">無</option>
                    <option value="1">10分鐘前</option>
                    <option value="2">30分鐘前</option>
                    <option value="3">1小時前</option>
                    <option value="4">1天前</option>
                  </select>
                </div>
              </div>
              <!-- <div class="row mb-3">
                <div class="col-3 font-weight-bold d-flex justify-content-end mt-2">
                  重複
                </div>
                <div class="col-9">
                  <select class="form-control select-100" v-model="recordData.rep_type">
                    <option value="0">無</option>
                    <option value="1">每日</option>
                    <option value="3">每週(不含六日)</option>
                    <option value="2">每週</option>
                    <option value="4">每兩週</option>
                    <option value="5">每工作月</option>
                  </select>
                </div>
              </div>
              <div class="row mb-3" v-show="recordData.rep_type != 0">
                <div class="col-3 font-weight-bold d-flex justify-content-end mt-2 pd-0">
                  重複結束日
                </div>
                <div class="col-9">
                  <div class="d-flex justify-content-between" style="width: 220px;">
                    <date-picker
                        v-model="recordData.rep_end_date"
                        :format="dateFormatter"
                        :language="dateLang"
                        :first-day-of-week="1" />
                  </div>
                </div>
              </div> -->
              <div class="row mb-3">
                <div class="col-3 font-weight-bold d-flex justify-content-end mt-2">
                  地址
                </div>
                <div class="col-9">
                  <input type="text"  v-model="recordData.addr" class="form-control" maxlength="100" @input="checkAddr" @blur="checkAddr">
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-3 font-weight-bold d-flex justify-content-end mt-2">
                  備註
                </div>
                <div class="col-9">
                  <textarea rows="5" v-model="recordData.memo" class="form-control" maxlength="600" @input="checkMemo" @blur="checkMemo"></textarea>
                </div>
              </div>
            </div>
            <div class="col-7">
              <div class="font-weight-bold mt-2">拜訪事件項目(至多5項)</div>
              <h4 class="text-green mt-2">增員拜訪</h4>
              <div class="btn-grids">
                <div class="btn btn-border-green"
                v-for="(btn, idx) in visitOpt"
                :key="`visit-item-${idx}`"
                @click="toggleSelect('visit', btn, idx)"
                :class="{'is-press': btn.common == true,}">

                  <!-- 固定的標籤 -->
                  <div role="button">
                    {{btn.name}}
                  </div>

                  <!-- 如果不是固定標籤的小叉叉 -->
                  <a v-if="!btn.default" class="close BBB"
                  @click="removeItem('visitOpt', idx, btn)">
                    <i class="icon-close"></i>
                  </a>

                </div>
                <!-- 加號小框 常用版-->
                <a role="button" class="btn btn-border-green add-new"
                v-if="selectOpt.length < 5"
                @click.stop.prevent="TagOpen('visit')">
                  <div role="button">
                    <i class="icon-add_new"></i>
                  </div>
                </a>
              </div>
              <hr >
              <h4 class="text-green mt-4">關係建立</h4>
              <div class="btn-grids">
                <div class="btn btn-border-green"
                v-for="(btn, idx) in relationOpt"
                :key="`relation-item-${idx}`"
                @click="toggleSelect('relation', btn, idx)"
                :class="{'is-press': btn.common == true,}">

                  <!-- 固定的標籤 -->
                  <div role="button">
                    {{btn.name}}
                  </div>

                  <!-- 如果不是固定標籤的小叉叉 -->
                  <a v-if="!btn.default" class="close BBB"
                  @click="removeItem('relationOpt', idx, btn)">
                    <i class="icon-close"></i>
                  </a>

                </div>
                
                <!-- 加號小框 常用版-->
                <a role="button" class="btn btn-border-green add-new"
                v-if="selectOpt.length < 5"
                @click.stop.prevent="TagOpen('relation')">
                  <div role="button">
                    <i class="icon-add_new"></i>
                  </div>
                </a>
              </div>
              <hr >
              <h4 class="text-green mt-4">需求分析</h4>
              <div class="btn-grids">
                <div class="btn btn-border-green"
                v-for="(btn, idx) in analizeOpt"
                :key="`analize-item-${idx}`"
                @click="toggleSelect('analize', btn, idx)"
                :class="{'is-press': btn.common == true,}">

                  <!-- 固定的標籤 -->
                  <div role="button">
                    {{btn.name}}
                  </div>

                  <!-- 如果不是固定標籤的小叉叉 -->
                  <a v-if="!btn.default" class="close BBB"
                  @click="removeItem('analizeOpt', idx, btn)">
                    <i class="icon-close"></i>
                  </a>

                </div>
                
                <!-- 加號小框 常用版-->
                <a role="button" class="btn btn-border-green add-new"
                v-if="selectOpt.length < 5"
                @click.stop.prevent="TagOpen('analize')">
                  <div role="button">
                    <i class="icon-add_new"></i>
                  </div>
                </a>
              </div>
              <hr >
              <h4 class="text-green mt-4">建議書/促約</h4>
              <div class="btn-grids">
                <div class="btn btn-border-green"
                v-for="(btn, idx) in recommandOpt"
                :key="`recommand-item-${idx}`"
                @click="toggleSelect('recommand', btn, idx)"
                :class="{'is-press': btn.common == true,}">

                  <!-- 固定的標籤 -->
                  <div role="button">
                    {{btn.name}}
                  </div>

                  <!-- 如果不是固定標籤的小叉叉 -->
                  <a v-if="!btn.default" class="close BBB"
                  @click="removeItem('recommandOpt', idx, btn)">
                    <i class="icon-close"></i>
                  </a>

                </div>
                
                <!-- 加號小框 常用版-->
                <a role="button" class="btn btn-border-green add-new"
                v-if="selectOpt.length < 5"
                @click.stop.prevent="TagOpen('recommand')">
                  <div role="button">
                    <i class="icon-add_new"></i>
                  </div>
                </a>
              </div>
              <hr>
              <h4 class="text-green mt-4">客戶服務</h4>
              <div class="btn-grids">
                <div class="btn btn-border-green"
                v-for="(btn, idx) in serviceOpt"
                :key="`service-item-${idx}`"
                @click="toggleSelect('service', btn, idx)"
                :class="{'is-press': btn.common == true,}">

                  <!-- 固定的標籤 -->
                  <div role="button">
                    {{btn.name}}
                  </div>

                  <!-- 如果不是固定標籤的小叉叉 -->
                  <a v-if="!btn.default" class="close BBB"
                  @click="removeItem('serviceOpt', idx, btn)">
                    <i class="icon-close"></i>
                  </a>

                </div>
                
                <!-- 加號小框 常用版-->
                <a role="button" class="btn btn-border-green add-new"
                v-if="selectOpt.length < 5 && selectedCommonTag.length < 3 && selectedCommonTag.length < 3"
                @click.stop.prevent="TagOpen('service')">
                  <div role="button">
                    <i class="icon-add_new"></i>
                  </div>
                </a>
              </div>
              <hr>
            </div>
          </div>
          <div class="actions text-right" v-if="edit === false">
            <a role="button" @click="submit()" class="btn btn-primary">送出</a>
          </div>
          <div class="actions text-right" v-if="edit === true">
            <a role="button" @click="panelOpen('warningModalOpen')" class="btn btn-default">刪除</a>
            <a role="button" @click="submit()" class="btn btn-primary">修改</a>
          </div>
        </div>
      </div>
    </div>
    <div id="scheduled-access-tag" v-show="scheduledAccessTagOpen">
      <div class="dropdown">
        <div class="modal-background-fixed"></div>
        <!-- <a role="button" id="visit-common-dropdown" class="btn btn-default btn-sm m-0 text-orange"
        @click.stop.prevent="showDropdown('visit', $event)" :disabled="selectOpt.length > 4">
          常用標籤
        </a> -->
        {{currentDropdown}}
        <div class="dropdown-menu common-tag"  :class="{'section-loading': tagLoading}">
          <a class="close" @click="TagClose"><i class="icon-close"></i></a>
          <div class="row">
            <div class="col-12"
            v-if="isCommonTagEdit">
              <div class="my-2"
              v-for="(tag, i) in commonTag"
              :key="`common-visit-edit-${i}`">
                <input type="text" v-model="tag.name" class="form-control h-43" maxlength="6" @input="checkTagName(i)" @blur="checkTagName(i)"/>
              </div>
            </div>
            <div class="col-12"
            v-else>
              <a class="btn btn-border-green my-2 btn-block"
              v-for="(tag, i) in commonTag"
              :key="`common-visit-${i}`"
              :class="hasCommonItem(tag.name) ? 'is-press' : ''"
              @click="toggleCommonSelect(tag)">
                <span v-if="tag.name.trim() != ''">{{ tag.name }}</span>
                <span v-else style="color:white">.</span>
              </a>
            </div>
          </div>
          <div class="row-cus">
            <div>
              <button 
              v-if="!isCommonTagEdit"
              @click.stop.prevent="isCommonTagEdit = !isCommonTagEdit" class="btn btn-icon btn-default btn-sm m-0">
                <i class="icon-edit"></i>
              </button>
              <button
              v-else 
              @click.stop.prevent="updateCustomItem" class="btn btn-primary btn-0">
                儲存
              </button> 
            </div>
            <!-- <div class="col-7 text-right">
              <a class="btn btn-primary btn-sm m-0"
              v-if="!this.isCommonTagEdit"
              @click.prevent="insertCommonTag()"
              :disabled="!selectedCommonTag.length">
                代入標籤
                <span v-if="selectedCommonTag.length">
                  {{selectedCommonTag.length}}/{{ (5 - selectOpt.length > 3) ? 3 : 5 - selectOpt.length}}
                </span>
              </a>
              <span v-else></span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <warning-modal
    :open="warningModalOpen"
    :message="warningMessage"
    @close="panelClose('warningModalOpen')"
    @submit="deleteSchedule" />
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {commonMixin} from '@/mixins/common'
import DatePicker from '@/components/DatePicker/components/Datepicker'
import {en, zh} from '@/components/DatePicker/locale'
import WarningModal from '@/desktop/components/WarningModal'
import { getCustDefaultItem, getCustVisitItem, editCustItem, getCustInfo, 
insertVisitEvent, queryVisitEvent, updateVisitEvent, deleteVisitEvent, setListAreaLog, addActionLog } from '@/service'

export default {
  name: 'ScheduledAccess',
  mixins: [commonMixin],
  components: { DatePicker,WarningModal },
  props: {
    record: {  // 客戶list 資料
      type: Object,
      default: () => {
        return null
      }
    },
    open: {
      type: Boolean,
      default: false
    },
    catInfo: {  // 專區資訊
      type: Object,
      default: () => {
        return {}
      }
    },
    isInjury: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      Loading: false,
      tagLoading: false,
      nameBir: '',
      selectedCommonTag: [],
      currentDropdownCount: 0,
      currentDropdown: '',
      isCommonTagEdit: false,
      selectOpt: [],
      selectedTag: {
        visit: [],
        relation: [],
        analize: [],
        recommand: [],
        service: []
      },
      removeCommonTag: [],
      commonTag: [
        {name: ''},
        {name: ''},
        {name: ''},
        {name: ''},
        {name: ''}
      ],
      commonTagSave: [],
      visitOpt: [],
      relationOpt: [],
      analizeOpt: [],
      recommandOpt: [],
      serviceOpt: [],
      dateLang: zh,
      dateFormatter: (date) => {
        const m = date.getMonth() + 1
        const d = date.getDate()
        return `${date.getFullYear() - 1911}/${(m < 10 ? '0' : '') + m}/${(d < 10 ? '0' : '') + d}`;
      },
      scheduledAccessTagOpen:false,
      recordData: {
				str_date: "",
        str_hour: "",
        str_minute: "",
        end_date: "",
        end_hour: "",
				end_minute: "",
				memo: "",
				rep_type: "0",
				remind_type: "0",
				addr: "",
        rep_end_date: ""
      },
      resetData: {
				str_date: "",
        str_hour: "",
        str_minute: "",
        end_date: "",
        end_hour: "",
				end_minute: "",
				memo: "",
				rep_type: "0",
				remind_type: "0",
				addr: "",
      },
      edit: false,
      warningModalOpen: false,
      warningMessage: "您是否確認要刪除該拜訪 ？",
      allDayEvent: false // 預設為關閉
    }
  },
  computed: {
    // visitLength 
    // relationLength
    // analizeLength
    // recommandLength
    // serviceLength
  },
  watch: {
    open (val) {  //  這邊判斷是新增或編輯
      if(val) {
        this.reset() // 清空資料
        if(this.record.visit.event_ser_no) {  // 有排訪紀錄
          this.edit = true
          this.editInit()  // 編輯初始化
        } else {  // 無排訪紀錄
          this.edit = false
          this.insertInit()  // 新增初始化
        }

        const listAreaSerNo = this.$store.state.listAreaSerNo
        const custInfo = this.$store.state.custInfo 
        const custId = custInfo.ID == '' ? custInfo.serNo : custInfo.ID
        if(listAreaSerNo){
          setListAreaLog(this.$store.state.userInfo.id,this.$store.state.listAreaSerNo,"3",this.record.id).then(result => { //新增名單專區log
            if (result.header && result.header.status == '200') {
              console.log('新增成功')
            }else{
              console.error('新增名單專區log API 錯誤')
            }
          }) 
        }else{
          addActionLog(this.$store.state.userInfo.id, "1", custId).then(result => { //新增業務員點擊LOG
            if (result.header && result.header.status == '200') {
              console.log('新增成功')
            }else{
              console.error('新增業務員點擊LOG API 錯誤')
            }
          }) 
        }
        
      }
    },
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    handleToggle() {
    },
    //檢查地址
    checkAddr(){
      this.recordData.addr= this.recordData.addr.replace(/[<>!#$^&,"'?%*:;+{}[\]|~`=\\]/g,'');
      if (this.stringBytes(this.recordData.addr, false, 100) > 100) {
        this.recordData.addr = this.recordData.addr.substring(0, this.stringBytes(this.recordData.addr, true, 100));
      }
    },
    //檢查備註欄位
    checkMemo(){
      if (this.stringBytes(this.recordData.memo, false, 600) > 600) {
        this.recordData.memo = this.recordData.memo.substring(0, this.stringBytes(this.recordData.memo, true, 600));
      }
    },
     //檢查標籤
    checkTagName(i){
      if (this.stringBytes(this.commonTag[i].name, false, 12) > 12) {
        this.commonTag[i].name = this.commonTag[i].name.substring(0, this.stringBytes(this.commonTag[i].name, true ,12));
      }
    },
    insertInit () {  // 新增初始化
      this.setInfo() // 設定生日跟地址
      this.setDate() // 設定日期跟時間
      this.recordData.memo = this.catInfo.category_name  // 設定備註預設帶入名單的名稱
      //傷害險相關標籤預設亮燈
      if (this.isInjury && this.serviceOpt && this.serviceOpt.length > 0) {
        for (let i = 0; i < this.serviceOpt.length; i++) {
          if (this.serviceOpt[i].code == "A0414") {
            this.serviceOpt[i].common = true; //按鈕亮燈
            this.selectOpt.push(this.serviceOpt[i]); //塞入已選擇標籤
            break;
          }
        }
      }      
    },
    editInit () {  // 編輯初始化
      this.editData = {}
      this.Loading = true
      //  先用 event serNo 查詢排訪資訊
      queryVisitEvent(this.$store.state.userInfo.id, this.record.visit.event_ser_no, this.record.visit.event_year).then(result => {
        this.Loading = false
        //  csidno 為空值代表不能編輯要轉成新增
        if(result.header && result.header.status == '200' && result.body.detail.csidno !== ''){
          this.editData = result.body.detail
          this.recordData.str_date = new Date(this.editData.str_date)
          this.recordData.str_hour = this.editData.str_time.split(':')[0]
          this.recordData.str_minute = this.editData.str_time.split(':')[1]
          this.recordData.end_date = new Date(this.editData.end_date)
          this.recordData.end_hour = this.editData.end_time.split(':')[0]
          this.recordData.end_minute = this.editData.end_time.split(':')[1]
          this.recordData.memo = this.editData.memo.includes(this.catInfo.category_name) ? this.editData.memo : this.catInfo.category_name + '.' + this.editData.memo
          this.recordData.rep_type = this.editData.rep_type
          this.recordData.remind_type = this.editData.remind_type
          this.recordData.addr = this.editData.addr
          this.setInfo() // 設定生日
          //  active 標籤
          const testCommon = /\w{3}9[5-9]/
          const filterAry = [
            {type: 'visitOpt', no: 'A05'},
            {type: 'relationOpt', no: 'A01'},
            {type: 'analizeOpt', no: 'A02'},
            {type: 'recommandOpt', no: 'A03'},
            {type: 'serviceOpt', no: 'A04'},
          ]
          this.selectOpt = this.editData.sub_cls_code.split(',').map(item => {
            if (testCommon.test(item)) {  //  如果是常用
              filterAry.forEach(filterItem => {
                if(item.includes(filterItem.no)) {this[filterItem.type].push({code: item.substr(0,3),common: true,name: item.substr(5)})}
              })
              return {code: item.substr(0,3),common: true,name: item.substr(5),}
            } else {  //  如果是固定
              filterAry.forEach(filterItem => {
                if(item.includes(filterItem.no)) {
                  this[filterItem.type].forEach((optItem, index) => {
                    if(item.includes(optItem.code)) {this[filterItem.type][index].common = true}
                  })
                }
              })
              return {code: item.substr(0,5),common: true,default: true,name: item.substr(5),}
            }
          })

        } else if (result.body.detail.csidno == '') {
          this.setToastMsg('「原排訪已被刪除,重新新增排訪」')
          this.edit = false
          this.insertInit()  // 新增初始化
        }else {
          console.log('查詢排訪 API 錯誤')
        }
      })
    },
    reset () {  // 清空資料
      this.recordData = {...this.resetData}  // 清空資料
      this.nameBir = ''
      // 清空已選標籤
      this.selectOpt = []  
      this.visitOpt = this.visitOpt.filter(item => {return item.default}).map(itme => {return {code: itme.code, default: true, name: itme.name,}})
      this.relationOpt = this.relationOpt.filter(item => {return item.default}).map(itme => {return {code: itme.code, default: true, name: itme.name,}})
      this.analizeOpt = this.analizeOpt.filter(item => {return item.default}).map(itme => {return {code: itme.code, default: true, name: itme.name,}})
      this.recommandOpt = this.recommandOpt.filter(item => {return item.default}).map(itme => {return {code: itme.code, default: true, name: itme.name,}})
      this.serviceOpt = this.serviceOpt.filter(item => {return item.default}).map(itme => {return {code: itme.code, default: true, name: itme.name,}})
    },
    setDate () { // 設定日期跟時間
      let nowTime = new Date(new Date().getTime() + 60000 * 60)  // 開始時間為現在時間加上一個小時
      let nextTime = new Date(nowTime.getTime() + 60000 * 60) // 現在時間加上一小時
      this.recordData.str_date = nowTime
      this.recordData.end_date = nextTime
      this.recordData.str_hour = nowTime.getHours().toString().length == 1 ? `0${nowTime.getHours()}` : nowTime.getHours().toString()
      this.recordData.str_minute = '00'
      this.recordData.end_hour = nextTime.getHours().toString().length == 1 ? `0${nextTime.getHours()}` : nextTime.getHours().toString()
      this.recordData.end_minute = '00'
    },
    setInfo () { // 設定生日及地址
      this.Loading = true
      getCustInfo(this.$store.state.userInfo.id, this.$store.state.userInfo.id, this.record.id).then(result => {
        this.Loading = false
        if(result.header && result.header.status == '200'){
          let customer = result.body.customer
          if (customer.birthday && customer.birthday !== '') {
            this.nameBir =  `${this.record.name}(${this.$options.filters.dateFormat(customer.birthday)})`
          } else {
            this.nameBir =  this.record.name
          }
          if(customer.home_addr1 && !this.edit) {
            this.recordData.addr = `${customer.home_addr1}${customer.home_addr2}${customer.home_addr3}`
          }
        }
        this.registerHanlink()  // for 難字更新
      })
    },
    doGetCustVisitItem () {  //查詢拜訪紀錄自訂標籤
      getCustVisitItem(this.$store.state.userInfo.id).then(result => { //查詢拜訪紀錄自訂標籤
        this.tagLoading = false
        if(result.header && result.header.status == '200'){
          const detailList = result.body.detail
          this.commonTag = [
            {name: detailList.cls_nm_1},
            {name: detailList.cls_nm_2},
            {name: detailList.cls_nm_3},
            {name: detailList.cls_nm_4},
            {name: detailList.cls_nm_5},
          ]
        }
        this.selectedCommonTag = []
        this.isCommonTagEdit = false
      })
    },
    updateCustomItem () {   // 編輯常用標籤
      let checkLimit = false
      this.commonTag.forEach(tag => {
        if(this.stringBytes(tag.name, false, 12) > 12){
          checkLimit = true
        }
      })
      if (checkLimit) {  // 驗證標籤長度
        return this.setToastMsg('常用標籤長度不得超過6個中文字')
      }
      this.tagLoading = true
      editCustItem(this.$store.state.userInfo.id, this.commonTag).then(result => {
        if(result.header && result.header.status == '200'){
          this.doGetCustVisitItem()
        }else{
          console.error('編輯常用標籤 API 錯誤')
        }
      })
    },
    //  插入常用標籤
    insertCommonTag () {
      let opt  = `${this.currentDropdown}Opt`
      const filterAry = [
        {type: 'visitOpt', no: 'A05'},
        {type: 'relationOpt', no: 'A01'},
        {type: 'analizeOpt', no: 'A02'},
        {type: 'recommandOpt', no: 'A03'},
        {type: 'serviceOpt', no: 'A04'},
      ]
      let codeType = filterAry.filter(item => {return item.type == opt})[0].no
      this.selectedCommonTag.forEach(item => {
        if(item.trim().length > 0){
          let isDuplicated = false
          this[opt].forEach(optItem => {
             if( optItem.name == item && optItem.code.substr(0,3) == codeType){
               isDuplicated = true
             }
          })
          if(!isDuplicated){
            this[opt].push({name: item, common: true, code: codeType})
            this.selectOpt.push({name: item, common: true, code: codeType})
          }        
        }
      })
      this.scheduledAccessTagOpen = false;
      this.selectedCommonTag = []
      this.isCommonTagEdit = false
    },
    commitTag (type, btn) {
      btn.edit = false  
      return false
    },
    hasCommonItem (tag) {
      return this.selectedCommonTag.indexOf(tag) > -1
    },
    toggleCommonSelect (btn) {
      if(!btn.name)
        return
      let type = `${this.currentDropdown}Opt`
      let index = this.selectedCommonTag.indexOf(btn.name)
      if (index > -1) {
        let id = 0
        this.selectedCommonTag.splice(index, 1)
        this.currentDropdownCount--
        this.removeCommonTag.push(btn)
      } else if(this.selectedCommonTag.length < (5 - this.selectOpt.length) && this.selectedCommonTag.length < 3) {
        this.currentDropdownCount++
        this.selectedCommonTag.push(btn.name)
      }
      this.insertCommonTag()
    },
    toggleSelect (type, btn, idx) {    // 切換固定標籤
      if(!btn.default) return false // 如果是常用標籤不切換class 或已選取五個標籤
      let checkHasName = false
      let BtnIndex = 0
      this.selectOpt.forEach((item, index) => {  // 確認標籤是否有被選擇
        if(item.code == btn.code){
          checkHasName = true
          BtnIndex = index
        }
      })
      if(checkHasName){ // 如果有被選擇
        this.selectOpt.splice(BtnIndex, 1)
        btn.common = false // 切換 class
      }else{     // 如果有沒被選擇 
        if (this.selectOpt.length < 5) {  // 5個時不增加
          this.selectOpt.push({...btn})
          btn.common = true  // 切換 class
        }
      }
    },
    removeItem (type, i, btn) {  // 移除常用標籤
      this[type].splice(i, 1)
      let removeInedx = -1
      this.selectOpt.forEach((item, index) => {
        if(item.name == btn.name){
          removeInedx = index
        }
      })
      if(removeInedx != -1){  // selectOpt 裡有編輯的標籤 移除該物件
        this.selectOpt.splice(removeInedx, 1)
      }
    },
    fmDate (date) {  // 轉換 Date 物件為 'YYYY-MM-DD' string
      if (typeof date == 'string') {
        const ptDash = /^\d{3}[\-\/]/g
        if(ptDash.test(date)) {  // 如果是民國年 轉成西元年
          let newDate = date.match(/^\d{3}/)[0] - 0 + 1911 + '' + date.replace(/^\d{3}/, '')
          return newDate
        } else {
          return date
        }
      } else {  // date 為 Date 物件
        let nowDateY = date.getFullYear().toString()
        let nowDateM = (date.getMonth() + 1).toString().length == 1 ? `0${(date.getMonth() + 1).toString()}` : (date.getMonth() + 1).toString()
        let nowDateD = date.getDate().toString().length == 1 ? `0${date.getDate().toString()}` : date.getDate().toString()
        return `${nowDateY}-${nowDateM}-${nowDateD}`
      }
    },
    fmTime (hour, minute) {  // 組合時間
      let newTime = `${hour}:${minute}:00`
      return newTime
    },
    reportCheck () {  //  驗證相關
      //  驗證標籤
      if(this.selectOpt.length > 5 || this.selectOpt.length == 0){  
        this.setToastMsg('標籤數量最少一個且不得超過五個')
        return false
      }
      let tagAry = this.selectOpt.map(item => {return item.code})
      let tagTest = []
      tagTest.push(tagAry.filter(item => item.includes('A01')).length)
      tagTest.push(tagAry.filter(item => item.includes('A02')).length)
      tagTest.push(tagAry.filter(item => item.includes('A03')).length)
      tagTest.push(tagAry.filter(item => item.includes('A04')).length)
      tagTest.push(tagAry.filter(item => item.includes('A05')).length)
      if(tagTest.filter(item => item > 3).length > 0) {
        this.setToastMsg('同類別標籤數量不得超過三個')
        return false
      }


      //  驗證時間
      const strTimeYMD = `${this.recordData.str_date.getFullYear()}/${this.recordData.str_date.getMonth()+1}/${this.recordData.str_date.getDate()}`
      const endTimeYMD = `${this.recordData.end_date.getFullYear()}/${this.recordData.end_date.getMonth()+1}/${this.recordData.end_date.getDate()}`
      const strTime = new Date(`${strTimeYMD} ${this.recordData.str_hour}:${this.recordData.str_minute}:00`).getTime()
      const endTime = new Date(`${endTimeYMD} ${this.recordData.end_hour}:${this.recordData.end_minute}:00`).getTime()
      const nowTime = new Date().getTime()
      
      if(endTime <= strTime){ 
        this.setToastMsg('結束時間不得等同或低於開始時間')
        return false
      }
      if(strTime < nowTime){  
        this.setToastMsg('不可排訂過去的時間')
        return false
      }

      // 驗證重複結束日
      // const startDate = new Date(this.recordData.str_date);
      // const repDate = new Date(this.recordData.rep_end_date);
      // if (repDate < startDate) {
      //   this.setToastMsg('僅可選擇開始時間之後的日期')
      //   return false;
      // }

      // // 計算今天加 3 個月
      // const today = new Date();
      // const threeMonthsLater = new Date(today);
      // threeMonthsLater.setMonth(threeMonthsLater.getMonth() + 3);
      // if (repDate > threeMonthsLater) {
      //   this.setToastMsg('重複結束日不能超過3個月')
      //   return false;
      // }
      // //  驗證重複類型
      // if(this.recordData.rep_type == ''){  
      //   this.setToastMsg('請選擇重複類型')
      //   return false
      // }

      //  驗證備註 600個字元
      if(this.stringBytes(this.recordData.memo, false, 600) > 600){
        this.setToastMsg('備註最長只能輸入600個字元')
        return false
      }

      return true
    },
    submit () {
      
      //  驗證相關
      if(!this.reportCheck()){ return false }

      // 過濾固定標籤
      let defaultList = this.selectOpt.filter(item => {return item.default}).map(item => {
        return `${item.code}${item.name}`
      })

      // 過濾常用標籤 並加上流水編95~99
      let commonList = this.selectOpt.filter(item => {return !item.default})
      commonList.forEach((item, index) => {
        item.code = item.code.substr(0,3) + (95 + index)
      })
      commonList = commonList.map(item => {
        return `${item.code}${item.name}`
      })

      // 固定標籤+常用標籤 再組成字串
      let combiString = [...defaultList,...commonList].join(',')

      if (this.edit) { // 編輯 submit
        this.editSubmit(combiString)
      } else {  // 新增 submit
        this.insertSubmit(combiString)
      }

    },
    insertSubmit (combiString) {  // 新增 submit
      let reportData = {
        input_id: this.$store.state.userInfo.id,  // 業務員ID
				str_date: this.fmDate(this.recordData.str_date),  // 拜訪開始日
				str_time: this.fmTime(this.recordData.str_hour, this.recordData.str_minute),  // 拜訪開始時間
				end_date: this.fmDate(this.recordData.end_date),  // 拜訪結束日
				end_time: this.fmTime(this.recordData.end_hour, this.recordData.end_minute),  // 拜訪結束時間
				main_cls_code: "A0000",  // 行事曆主分類 (固定值)
				sub_cls_code: combiString,  // 行事曆次分類
				lvl_cls: "0",  // 層級 (固定值)
				mngr_join: "N",  // 主管是否參加  (固定值)
				title: this.record.name,  // 客戶姓名
				memo: this.recordData.memo,  // 備註
				rep_type: this.recordData.rep_type,  // 重複類型
				is_done: "N",  // 是否完成 (固定值)
				updt_id: this.$store.state.userInfo.id,  // 更新業務員ID
				data_src: "3",  // 來源 (固定值)
				del_mark: "I",  // 狀態標記 新增為 I 編輯為 U
				remind_type: this.recordData.remind_type,  // 提醒類別
				csidno: this.record.id,  // 客戶ID
				addr: this.recordData.addr,  // 客戶地址
				latitude: "",  // 緯度
				longitude: "",  // 緯度
				list_ser_no: this.catInfo.ser_no, // 專區流水編
      }
      this.Loading = true
      insertVisitEvent(this.$store.state.userInfo.id, reportData).then(result => {
        this.Loading = false
        if(result.header && result.header.status == '200'){
          this.setToastMsg(result.header.message)
          this.$emit('submit')
        } else {
          this.setToastMsg(result.header.message)
        }
      })
    },
    editSubmit (combiString) {  // 編輯 submit
      let reportData = {
        input_id: this.$store.state.userInfo.id,  // 業務員ID
				str_date: this.fmDate(this.recordData.str_date),  // 拜訪開始日
				str_time: this.fmTime(this.recordData.str_hour, this.recordData.str_minute),  // 拜訪開始時間
				end_date: this.fmDate(this.recordData.end_date),  // 拜訪結束日
				end_time: this.fmTime(this.recordData.end_hour, this.recordData.end_minute),  // 拜訪結束時間
				main_cls_code: "A0000",  // 行事曆主分類 (固定值)
				sub_cls_code: combiString,  // 行事曆次分類
				lvl_cls: "0",  // 層級 (固定值)
				mngr_join: "N",  // 主管是否參加 (固定值)
				title: this.record.name,  // 客戶姓名
				memo: this.recordData.memo,  // 備註
				rep_type: this.recordData.rep_type,  // 重複類型
				is_done: "N",  // 是否完成 (固定值)
				updt_id: this.$store.state.userInfo.id,  // 更新業務員ID
				data_src: "3",  // 來源 (固定值)
				del_mark: "U",  // 狀態標記 新增為 I 編輯為 U
				remind_type: this.recordData.remind_type,  // 提醒類別
				csidno: this.record.id,  // 客戶ID
				addr: this.recordData.addr,  // 客戶地址
				latitude: "",  // 緯度
        longitude: "",  // 緯度
        event_ser_no: this.record.visit.event_ser_no,	 // 事件序號
        event_year: this.record.visit.event_year,  // 事件年份
      }
      
      this.Loading = true
      updateVisitEvent(this.$store.state.userInfo.id, reportData).then(result => {
        this.Loading = false
        if(result.header && result.header.status == '200'){
          this.setToastMsg(result.header.message)
          this.$emit('submit')
        } else {
          this.setToastMsg(result.header.message)
        }
      })
    },
    deleteSchedule() {  //  刪除排訪
      this.panelClose('warningModalOpen')

      let reportData = {
        input_id: this.$store.state.userInfo.id,  // 業務員ID
				str_date: this.record.visit.str_date,  // 拜訪開始日
				str_time: this.record.visit.str_time,  // 拜訪開始時間
        event_ser_no: this.record.visit.event_ser_no,	 // 事件序號
        event_year: this.record.visit.event_year,  // 事件年份
      }
      
      this.Loading = true
      deleteVisitEvent(this.$store.state.userInfo.id, reportData).then(result => {
        this.Loading = false
        if(result.header && result.header.status == '200'){
          this.setToastMsg(result.header.message)
          this.$emit('submit')
        } else {
          this.setToastMsg(result.header.message)
        }
      })
      
    },
    //  打開新增常用標籤視窗
    TagOpen(type) {
      this.selectedCommonTag = [];
      this.scheduledAccessTagOpen = true;
      this.currentDropdown = type
      this.commonTagSave = [...this.commonTag];
    },
    TagClose(){
      if (this.isCommonTagEdit) {
        this.setToastMsg('請儲存標籤')
      } else {
        this.scheduledAccessTagOpen = false
        this.commonTag = [...this.commonTagSave]
      }
    },
    initDefaultTag() {
      getCustDefaultItem(this.$store.state.userInfo.id).then(result => {  //查詢拜訪紀錄固定標籤
        if(result.header && result.header.status == '200'){
          this.relationOpt = []
          this.analizeOpt = []
          this.recommandOpt = []
          this.serviceOpt = []
          this.visitOpt = []
          this.selectOpt = []
          let modifyData = result.body.cls_item.map(item => {
            return {name:item.cls_nm, code:item.cls_code, default: true}
          })
          // 添加固定的標籤
          modifyData.forEach(item => {
            if(item.code.includes('A01')){  // 關係建立(A01)
              this.relationOpt.push(item)
            }else if(item.code.includes('A02')){  // 需求分析(A02)
              this.analizeOpt.push(item)
            }else if(item.code.includes('A03')){  // 建議書/促約(A03)
              this.recommandOpt.push(item)
            }else if(item.code.includes('A04')){  // 客戶服務(A04)
              this.serviceOpt.push(item)
            }else if(item.code.includes('A05')){  // 增員拜訪(A05)
              this.visitOpt.push(item)
            }
          })
        }else{
          console.error('查詢拜訪紀錄固定標籤 API 錯誤')
        }
      })
    },
    stringBytes(c, isSub, size){ //計算字元長度 (字串, 是否檢查, 檢查的長度) 
      var n=c.length,s;
      var len=0;
      for(var i=0; i <n;i++){
        s=c.charCodeAt(i);
        while( s > 0 ){
          len++;
          s = s >> 8;
          if(isSub&&len>size){
            return i;
          }
        }
      }
      return len;
    }
  },
  mounted () {

    //  取回固定標籤
    this.initDefaultTag()

    //  查詢常用標籤
    this.doGetCustVisitItem()
  }
}
</script>

<style>
.vdp-datepicker input {
  width: 100px;
  padding: 10px;
}
.select-100 {
  width: 170px;
}
.select-time {
  width: 48px;
  padding:5px !important;
}
.non-select-arrow  {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: '';
}
.btn-grids .btn {
  position: relative;
  padding: 8px;
  width: 24%;
  font-size: 1rem;
  margin: 0px;
  margin-bottom: 10px;
  margin-right: 1%;
}
.btn-grids .add-new{
  padding: 8px;
  width: 50px !important;
  font-size: 16px;
}
.btn-grids .btn .close {
  position: absolute;
  right: -10px;
  top: -10px;
}

#scheduled-access-tag .dropdown{
  position: relative;
  display:block;
}

#scheduled-access-tag .dropdown-menu{
  position: fixed;
  display:block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 248px;
  padding: 40px;
  padding-top: 40px;
  padding-bottom: 25px;
  border-radius: 8px;
}
#scheduled-access-tag .modal-background-fixed {
  position: fixed;
  background: rgba(0,0,0,0.5);
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
#scheduled-access-tag .close {
  position: absolute;
  font-size: 16px;
  width: 24px;
  height: 24px;
  right: 0;
  top: 0;
  margin-right: -12px;
  margin-top: -12px;
  display: block;
  color: #FFF;
  text-align: center;
  line-height: 24px;
  padding: 0;
  background: #5B616A;
  border: 1px solid #FFF;
  border-radius: 12px;
  -webkit-box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.8);
  -ms-box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.8);
  -o-box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.8);
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.8);
}

.row-cus {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;
  margin: 10px 0px 0px 0px;
}

.icon-edit {
  height: 30px;
  width: 30px;
}

.h-43 {
  height: 43px !important;
}

.btn-0 {
  padding: 7px 15px !important;
}

.f-size-15 {
  font-size: 15px;
}

.pd-0 {
  padding: 0;
}

.switch-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 3px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0; left: 0;
  right: 0; bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 24px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

/* checked 狀態 */
input:checked + .slider {
  background-color: #00AA42;
}

input:checked + .slider:before {
  transform: translateX(18px);
}
</style>